// Voice data mirrored from functions/ea/*/character.js for frontend use.
// Keep in sync with the character modules — backend uses those directly.

export const RACHEL_VOICES = [
  { id: 'ztqW7U07ITK9TRp5iDUi', label: 'Rachel - Primary' },
];

export const SARA_VOICES = [
  { id: 'BqV7FvOFFhPNhRcqujKF', label: 'Sara - Primary' },
  { id: 'mTzAy6T6Mo4mQx6wbZhJ', label: 'Sara - Alt 1' },
];

export const SELENE_VOICES = [
  { id: 'cgSgspJ2msm6clMCkdW9', label: 'Selene - Primary' },
];

export const ADAM_VOICES = [
  { id: 'pqHfZKP75CvOlQylNhV4', label: 'Adam - Primary' },
  { id: 'mI8xLTBNjMXAf31I4xlB', label: 'Adam - Alt 1' },
];
